import { render, staticRenderFns } from "./BacklogModal.vue?vue&type=template&id=130a9d00&scoped=true&"
import script from "./BacklogModal.vue?vue&type=script&lang=js&"
export * from "./BacklogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a9d00",
  null
  
)

export default component.exports